<template>
  <div>
    <div v-for="(content, index) in this.episodes" :key="index">
      <div
        @click="
          $router.push({ path: '/episode/' + content.episode_id });
          $store.commit('updateEpisodeId', content.episode_id);
          $store.commit('updateEpisodeIndex', content.episode_index);
          $store.commit('updateEpisodeLength', content.episode_length);
        "
        class="card"
      >
        <div
          class="container"
          :class="{
            'eyal-weizman-filter': index == 0,
            'benedicte-savoy-filter': index == 1,
            'priya-basil-filter': index == 2,
            'fred-ritchin-filter': index == 3,
            'rabih-mroue-filter': index == 4,
            'christina-varvia-filter': index == 5,
            'claudia-jimenez-filter': index == 6,
            'mark-sealy-filter': index == 7,
            'ixmucane-aguilar-filter': index == 8,
          }"
        >
          <img
            :src="require('../assets/speaker/' + content.speaker + '.jpg')"
            alt=""
          />

          <div class="bottom-left">{{ content.title }}</div>
        </div>
        <div class="subtitle">
          {{ content.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ecchr_config from "../data/ecchr_config.json";
export default {
  name: "EpisodeCards",
  props: {
    msg: String,
  },
  data() {
    return {
      episodes: ecchr_config["episode_cards"],
    };
  },
};
</script>

<style scoped>
.card {
  position: relative;
  z-index: 0;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  transition: 0.3s;
  border-radius: 15px;
  background-color: rgba(44, 44, 44, 1);
  margin: 20px;
}

.card:hover {
  cursor: pointer;
}

.container {
  position: relative;
  height: 100%;
  content: "";
}

.container:after {
  position: absolute;
  content: "";
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  border-radius: 15px 15px 0 0;
}
.eyal-weizman-filter:after {
  background: linear-gradient(180deg, rgb(187, 119, 55, 0.5) 20%, #000 100%);
  /* opacity: 0.45; */
}
.benedicte-savoy-filter:after {
  background: linear-gradient(180deg, rgb(248, 191, 45, 0.5) 20%, #000 100%);
}
.priya-basil-filter:after {
  background: linear-gradient(180deg, rgb(147, 109, 255, 0.5) 20%, #000 100%);
}
.fred-ritchin-filter:after {
  background: linear-gradient(180deg, rgba(36, 104, 205, 0.5) 20%, #000 100%);
}
.rabih-mroue-filter:after {
  background: linear-gradient(180deg, rgba(240, 87, 170, 0.5) 20%, #000 100%);
}
.christina-varvia-filter:after {
  background: linear-gradient(180deg, rgba(148, 181, 192, 0.5) 0%, #000 100%);
}
.claudia-jimenez-filter:after {
  background: linear-gradient(180deg, rgba(232, 79, 125, 0.5) 0%, #000 100%);
}
.mark-sealy-filter:after {
  background: linear-gradient(180deg, rgba(127, 105, 191, 0.5) 20%, #000 100%);
}
.ixmucane-aguilar-filter:after {
  background: linear-gradient(180deg, rgba(85, 162, 205, 0.5) 20%, #000 100%);
}

.bottom-left {
  position: absolute;
  bottom: 10px;
  margin-right: 20px;
  left: 20px;
  font-size: 18px;
  font-weight: 700;
  text-align: left;
  z-index: 1;
}

img {
  width: 100%;
  height: 100%;
  border-radius: 15px 15px 0 0;
}

.subtitle {
  color: rgba(235, 235, 245, 1);
  padding: 8px 80px 12px 20px;
  font-size: 14px;
  line-height: 130%;
}
</style>
